import React from "react";
import { Bar } from "react-chartjs-2";
import { Box, Paper } from "@mui/material";
import ChartDataLabels from "chartjs-plugin-datalabels";

const StatsBasicBarChart = (props) => {
  const {
    labels,
    priamryPlayerData,
    primaryPlayerName,
    otherPlayerdata,
    nameOtherPlayer,
    chartName,
    max,
  } = props;

  const data = {
    labels: labels,
    datasets: [
      {
        label: primaryPlayerName,
        data: priamryPlayerData,
        backgroundColor: "rgb(186 28 28 / 87%)",
        borderColor: "rgb(186 28 28 / 87%)",
        borderWidth: 1,
        fill: false,
      },
      {
        label: nameOtherPlayer,
        data: otherPlayerdata,
        backgroundColor: "rgb(32 66 132)",
        borderColor: "rgb(32 66 132)",
        borderWidth: 1,
        fill: false,
      },
    ],
  };

  const options = {
    indexAxis: "x",
    scales: {
      x: {
        ticks: {
          autoSkip: false,
          maxRotation: 45,
          minRotation: 45,
          padding: 10,
        },
      },
      y: {
        ticks: {
          stepSize: 5,
          suggestedMin: 0,
          suggestedMax: max || 100,
        },
        grid: {
          display: false,
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        labels: {
          usePointStyle: true,
        },
      },
      title: {
        display: true,
        text: chartName,
        font: {
          size: 16,
          weight: "bold",
        },
      },
      datalabels: {
        color: "#000",
        anchor: "end", // Position of the label relative to its data point
        align: "top", // Alignment of the label text
        font: {
          weight: "bold", // Set font weight to bold
        },
        formatter: (value) => value, // Format the label as needed
      },
    },
    responsive: true,
    layout: {
      padding: 20,
    },
    elements: {
      bar: {
        barPercentage: 0.5,
      },
    },
    interaction: {
      intersect: false,
    },
    aspectRatio: 1.9,
  };

  return (
    <Box mt={2} mb={2}>
      <Paper elevation={2} sx={{ backgroundColor: "#F5F5F5" }}>
        <Bar data={data} plugins={[ChartDataLabels]} options={options} />
      </Paper>
    </Box>
  );
};

export default StatsBasicBarChart;
